module.exports = __webpack_public_path__ + "static/scale-model-of-sarah-jane-park-in-springfield-massachusetts-69f012491b5da787062236e85ecae44f.png";